export enum FormFieldState{
    success = "success",
    error = "error",
    normal = "normal"
}